import { useCallback, useEffect, useState } from 'react';

// ----------------------------------------------------------------------

interface ReturnType {
  value: boolean;
  setTrue: () => void;
  setFalse: () => void;
  onToggle: () => void;
  setValue: React.Dispatch<React.SetStateAction<boolean>>;
}

export function useBoolean(defaultValue: boolean = false): ReturnType {
  const [value, setValue] = useState(defaultValue);

  const setTrue = useCallback(() => {
    setValue(true);
  }, []);

  const setFalse = useCallback(() => {
    setValue(false);
  }, []);

  const onToggle = useCallback(() => {
    setValue(prev => !prev);
  }, []);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return {
    value,
    setTrue,
    setFalse,
    onToggle,
    setValue,
  };
}
